<template>
  <div class="container mt-lg">
    <div class="row justify-content-center mt--150">
      <div class="col-lg-8">
        <div ref="contactForm" id="contactForm" class="card bg-gradient-secondary shadow">
          <div class="card-body p-lg-5">
            <h4 class="mb-1">Want to work with us?</h4>
            <p class="mt-0">Your project is very important to us.</p>
            <div
              v-if="success"
              class="alert alert-success"
              role="alert"
            >Thank you for contacting us. We will get in touch shortly.</div>
            <div
              v-if="error"
              class="alert alert-danger"
              role="alert"
            >Something went wrong, please try again.</div>
            <form v-on:submit.prevent="submit">
              <div class="g-recaptcha" data-sitekey="6LeBq6AUAAAAADnF4GQH3C0icbKwtDt5K_wbB6gS"></div>

              <div class="form-group mt-3">
                <div class="input-group input-group-alternative">
                  <div class="input-group-prepend">
                    <span class="input-group-text">
                      <i class="ni ni-user-run"></i>
                    </span>
                  </div>
                  <input
                    class="form-control"
                    v-model="form.name"
                    placeholder="Your name"
                    type="text"
                  >
                </div>
                <small
                  v-if="getError('name')"
                  id="passwordHelpBlock"
                  class="form-text text-danger"
                >{{getError('name')}}</small>
              </div>
              <div class="form-group">
                <div class="input-group input-group-alternative">
                  <div class="input-group-prepend">
                    <span class="input-group-text">
                      <i class="ni ni-email-83"></i>
                    </span>
                  </div>
                  <input
                    class="form-control is-invalid"
                    v-model="form.email"
                    placeholder="Email address"
                    type="email"
                  >
                </div>
                <small
                  v-if="getError('email')"
                  id="passwordHelpBlock"
                  class="form-text text-danger"
                >{{getError('email')}}</small>
              </div>
              <div class="form-group mb-4">
                <textarea
                  class="form-control form-control-alternative"
                  v-model="form.message"
                  rows="4"
                  cols="80"
                  placeholder="Type a message..."
                ></textarea>
                <small
                  v-if="getError('message')"
                  id="passwordHelpBlock"
                  class="form-text text-danger"
                >{{getError('message')}}</small>
              </div>

              <div>
                <button
                  type="submit"
                  class="btn btn-default btn-round btn-block btn-lg"
                >Send Message</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { setTimeout } from "timers";
export default {
  name: "ArgonContactForm",
  data: () => ({
    form: {
      name: "",
      email: "",
      message: ""
    },
    errors: {},
    success: false,
    error: false
  }),
  mounted() {
    const { contactForm } = this.$refs;
    this.$store.commit("footer/setContactRef", contactForm);
  },
  methods: {
    getError(field) {
      return this.errors[field] ? this.errors[field][0] : "";
    },
    submit(submitEvent) {
      let token = submitEvent.target.elements["g-recaptcha-response"].value;
      let contact = { "g-recaptcha-response": token, ...this.form };
      this.success = false;
      this.error = false;
      axios
        .post("http://localhost:4000/api/contacts", { contact: contact })
        .then(response => {
          this.errors = {};
          this.form = {
            name: "",
            email: "",
            message: ""
          };
          this.success = true;
          setTimeout(() => {
            this.success = false;
          }, 10000);
        })
        .catch(error => {
          this.error = true;

          // this.errors = error.response.data.errors;
        });
    }
  }
};
</script>
